import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, Alert} from "reactstrap";
import ReactTable from "react-table";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Select from "react-select";

export default class UsersActive extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Users_Active._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [

			{
				Header: "User",
				id: 'users',
				/** @param {Users_Object} obj */
				accessor: obj => obj.users ? (obj.users.name_first + ' ' + obj.users.name_last) : '',
			},
			{
				Header: "Current Status",
				Cell: props => {
					return (
						<span style={{color: props.original.color}}>
							{props.original.active === false ? 'Scheduled today but has not been online' : (props.original.color === 'green' ? 'Active in the last 10 minutes' : props.original.color === 'yellow' ? 'Active in the last 15 minutes' : props.original.color === 'orange' ? 'Active in the last 20 minutes' : props.original.color === 'purple' ? 'Likely at lunch, active in the last hour' : props.original.color === 'red' ? 'Active earlier today, but no longer online' : 'Scheduled today but has not been online')}
						</span>
					);
				}
			},
			{
				Header: "Last Activity (AZ)",
				id: 'time',
				/** @param {Users_Object} obj */
				accessor: obj => obj.time ? obj.time : 'N/A',
			},
			// {
			// 	Header: "Active Today",
			// 	className: "button-cell",
			// 	width: 175,
			//
			// 	Cell: props => {
			// 		return (
			// 			<span>
			// 				{props.original.active === true ?
			// 					<Button color="green-meadow" size={"sm"} block={true}>
			// 						Yes</Button>
			// 					: <Button color="danger" size={"sm"} block={true}>No</Button>
			// 				}
			// 			</span>
			// 		);
			// 	}
			// },

		]
		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderHeaderRight("Active_Users", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
